// 阿拉伯语
export default {
  // 水果转盘
  fruitTurntable: {
    recordsTitle: "السجل",
    emptyRecords: "لا توجد سجلات لروليت الفواكه بعد",
    guessResult: "نتيجة التوقع",
    myGuesses: "توقعاتي",
    guessFailed: "توقع غير صحيح",
    winningPlayers: "اللاعبون الفائزون",
    noGuesses: "لم تقدم أي توقعات في هذه الجولة",
    noWinners: "لا يوجد لاعبون فائزون في هذه الجولة",
    rulesTitle: "طريقة اللعب",
    rulesDescription: "تمنحك كل جولة 50 ثانية لتوقع الفاكهة التي ستظهر. التوقع الصحيح يمنحك مكافأة الندى المقابلة.",
    guessingTitle: "طريقة التوقع",
    guessingDescription: "خلال فترة التوقع، اختر كمية الندى التي تريد المراهنة بها، ثم اضغط على منطقة المراهنة الخاصة بالفاكهة على الشاشة.",
    rewardsTitle: "المكافآت",
    rewardsDescription: "تمنح الفواكه المختلفة مكافآت ندى مختلفة.",
    fruit: "الفاكهة",
    multiplier: "مضاعف المكافأة",
    apple: "تفاح",
    watermelon: "بطيخ",
    orange: "برتقال",
    banana: "موز",
    grape: "عنب",
  },
  setPresident: {
    intro: "يمكنك تعيين رئيس للمساعدة في إدارة ناديك",
    selfIntro: "أنت رئيس النادي",
    president: "الرئيس",
    empty: "لم يتم تعيين رئيس",
    appoint: "تعيين",
    privileges: "صلاحيات الرئيس",
    privilegesIntro: "يتمتع الرئيس بالصلاحيات التالية",
    title: "تعيين رئيس",
    selectMember: "اختر العضو الذي تريد تعيينه رئيسًا",
    member: "عضو",
    attendance: "الحضور: {days} يوم",
    weekContribution: "المساهمة في السمعة (أسبوع):",
    monthContribution: "(شهر):",
    confirmAppoint: "هل تريد تعيين هذا العضو رئيسًا؟",
    confirm: "تأكيد",
    remove: "إعفاء من المنصب",
    cancel: "إلغاء",
    removeTitle: "إعفاء رئيس النادي",
    confirmRemove: "هل تريد إعفاء {name} من منصب رئيس النادي؟",
    unnamed: "بدون اسم",
    pkTitle: "غرف PK",
    pkDesc: "يمكن للرئيس فتح غرف PK الخاصة بالنادي وإغلاقها وإدارتها",
    infoTitle: "معلومات النادي",
    infoDesc: "يمكن للرئيس ومالك النادي تعديل صورة الغلاف والاسم والشعار وغيرها من معلومات النادي",
    membersTitle: "إدارة الأعضاء",
    membersDesc: "يمكن للرئيس ومالك النادي إزالة أعضاء النادي وضيوفه",
    rewardsTitle: "مكافآت النادي",
    rewardsDesc: "يمكن للرئيس استلام مكافآت النادي. لا يمكن استلامها إذا لم يتم تعيين رئيس",
    moderationTitle: "الإشراف على غرفة البث",
    moderationDesc: "يحصل الرئيس تلقائيًا على صلاحيات الإشراف في غرفة البث الخاصة بمالك النادي",
    newPlayersTitle: "قناة اللاعبين الجدد",
    newPlayersDesc: "يمكن للرئيس ومالك النادي الاطلاع على قناة اللاعبين الجدد",
    loadMembersFailed: "تعذر تحميل قائمة الأعضاء",
    appointFailed: "تعذر تعيين الرئيس",
    appointSuccess: "تم التعيين بنجاح",
    removeFailed: "تعذر الإعفاء من المنصب",
    removeSuccess: "تم الإعفاء بنجاح",
    customerService: "خدمة العملاء",
    loadClubFailed: "تعذر تحميل معلومات النادي",
  },
  /* 總榜單 */
  allRank: {
    lang1: "المذيع",
    lang2: "ثري",
    lang3: "PK",
    lang4: "معركة النادي",
    lang5: "صينى",
    lang6: "إنجليزي",
    lang7: "التايلاندية",
    lang8: "اليابانية",
    lang9: "الأندونيسية",
    lang10: "فيتنامي",
    lang11: "ساعة",
    lang12: "يوميًا",
    lang13: "أسبوعي",
    lang14: ".هذا الاسبوع",
    lang15: "الأسبوع الماضي",
    lang16: "شهريا",
    lang17: "قائمة الرتب",
    lang18: "جائزة",
    lang19: "معدل الاتصال",
    lang20: "نقاط النادي",
    lang21: "عضو",
    lang22: "لايوجد بيانات",
    lang23: "غير مدرج بعد",
    lang24: "نادي المعجبين",
    lang25: "تاريخ",
    lang26: "لا تستطيع متابعة نفسك",
    lang27: "اتبع بنجاح",
    lang28: "تم إلغاء المتابعة بنجاح",
    lang29: "منتظر",
    lang30: "البارحة",
    lang31: "في الشهر الماضي",
    lang32: "ليس في القائمة",
    lang33: "بلدي الترتيب",
    lang34: "المبعوث",
    lang35: "قائمة المكافآت الشهرية",
    lang36: "قائمة شهرية للتلاميذ",
    lang37: "Club",
    lang38: "Fans group",
    lang39: "لا يوجد شعار",
    lang40: "عضو",
    lang41: "عضو",
    lang42: "سمعة الأسبوع",
    lang43: "السمعة الشاملة",
    lang44: "ترتيب النادي",
    lang45: "شارك",
    lang46: "إطلاق",
    lang47: "أرسل دعوة للنادي",
    lang48: "قم بإطلاق FIREFLY للاستمتاع بمزيد من البث المباشر",
    lang49: "ترتيب المكافآت الأسبوعية",
    lang50: "ترتيب المبلغ الأسبوعي",
    lang51: "السمعة",
    lang52: "مكافأة",
  },

  /* 俱乐部 */
  club: {
    lang1: "المذيع",
    lang2: "ثري",
    lang3: "PK",
    lang4: "معركة النادي",
    lang5: "صينى",
    lang6: "إنجليزي",
    lang7: "التايلاندية",
    lang8: "اليابانية",
    lang9: "الأندونيسية",
    lang10: "فيتنامي",
    lang11: "ساعة",
    lang12: "يوميًا",
    lang13: "أسبوعي",
    lang14: ".هذا الاسبوع",
    lang15: "الأسبوع الماضي",
    lang16: "شهريا",
    lang17: "قائمة الرتب",
    lang18: "جائزة",
    lang19: "معدل الاتصال",
    lang20: "نقاط النادي",
    lang21: "عضو",
    lang22: "لايوجد بيانات",
    lang23: "غير مدرج بعد",
    lang24: "نادي المعجبين",
    lang25: "تاريخ",
    lang26: "لا تستطيع متابعة نفسك",
    lang27: "اتبع بنجاح",
    lang28: "تم إلغاء المتابعة بنجاح",
    lang29: "منتظر",
    lang30: "نقطة مساهمة الرسم البياني",
    lang31: "درجة",
    lang37: "Club",
    lang38: "Fans group",
    lang39: "لا يوجد شعار",
    lang40: "عضو",
    lang41: "عضو",
    lang42: "سمعة الأسبوع",
    lang43: "السمعة الشاملة",
    lang44: "ترتيب النادي",
    lang45: "شارك",
    lang46: "إطلاق",
    lang47: "أرسل دعوة للنادي",
    lang48: "افتح FIREFLY وانضم إلى النادي لنستمتع معًا~",
    lang49: "Fans group",
    lang50: "اللورد: ",
    lang51: "الرئيس: ",
    // وسم الدور في صف "ترتيبي" بصفحة ترتيب النوادي.
    lang52: "اللورد",
    lang53: "الرئيس",
    lang54: "عضو",

    lang55: "لا انتماء لنادٍ",

    lang56: "لم يتم تعيين نادٍ تابع",
  },

  /* 榜单 */
  rank: {
    lang1: "المذيع",
    lang2: "ثري",
    lang3: "PK",
    lang4: "معركة النادي",
    lang5: "صينى",
    lang6: "إنجليزي",
    lang7: "التايلاندية",
    lang8: "اليابانية",
    lang9: "الأندونيسية",
    lang10: "فيتنامي",
    lang11: "ساعة",
    lang12: "يوميًا",
    lang13: "أسبوعي",
    lang14: ".هذا الاسبوع",
    lang15: "الأسبوع الماضي",
    lang16: "شهريا",
    lang17: "قائمة الرتب",
    lang18: "جائزة",
    lang19: "معدل الاتصال",
    lang20: "نقاط النادي",
    lang21: "عضو",
    lang22: "لايوجد بيانات",
    lang23: "غير مدرج بعد",
    lang24: "نادي المعجبين",
    lang25: "تاريخ",
    lang26: "لا تستطيع متابعة نفسك",
    lang27: "اتبع بنجاح",
    lang28: "تم إلغاء المتابعة بنجاح",
    lang29: "منتظر",
    lang30: "البارحة",
    lang31: "في الشهر الماضي",
    lang32: "ليس في القائمة",
    lang33: "بلدي الترتيب",
    newDraw96: "مكالمة خاصة",
  },

  /* TOP hub */
  topRankList: {
    title: "FIREFLY TOP Center",
    playerCoreTitle: "Player Core TOP",
    playerCoreSubTitle: "Top Rich",
    anchorCoreTitle: "Broadcaster Core TOP",
    anchorCoreSubTitle: "Top FIREs",
    playerCenterTitle: "Player Rankings",
    playerCenterSubTitle: "Ranking Center",
    anchorCenterTitle: "Broadcaster Rankings",
    anchorCenterSubTitle: "FIREs Ranking Center",
    richBoard: "FIREFLY Rich Ranking",
    anchorBoard: "FIREFLY Broadcaster Ranking",
    clubBoard: "Club Ranking",
    emissaryBoard: "Emissary Ranking",
    mountBoard: "Car Ranking",
    ludoBoard: "LUDO PK Ranking",
    gardenBoard: "Firefly Garden Ranking",
    firstLoveBoard: "FirstLove Ranking",
    newStarBoard: "New Star Ranking",
    pkBoard: "PK Ranking",
    privateCreditBoard: "Private Credit Ranking",
  },

  /* 珍愛團 */
  treasureGroup: {
    lang1: "المذيع",
    lang2: "ثري",
    lang3: "PK",
    lang4: "معركة النادي",
    lang5: "صينى",
    lang6: "إنجليزي",
    lang7: "التايلاندية",
    lang8: "اليابانية",
    lang9: "الأندونيسية",
    lang10: "فيتنامي",
    lang11: "ساعة",
    lang12: "يوميًا",
    lang13: "أسبوعي",
    lang14: ".هذا الاسبوع",
    lang15: "الأسبوع الماضي",
    lang16: "شهريا",
    lang17: "قائمة الرتب",
    lang18: "جائزة",
    lang19: "معدل الاتصال",
    lang20: "نقاط النادي",
    lang21: "عضو",
    lang22: "لايوجد بيانات",
    lang23: "غير مدرج بعد",
    lang24: "نادي المعجبين",
    lang25: "تاريخ",
    lang26: "لا تستطيع متابعة نفسك",
    lang27: "اتبع بنجاح",
    lang28: "تم إلغاء المتابعة بنجاح",
    lang29: "منتظر",
    lang30: "نقطة مساهمة الرسم البياني",
    lang31: "درجة",
    lang37: "Club",
    lang38: "Fans group",
    lang39: "لا يوجد شعار",
    lang40: "عضو",
    lang41: "عضو",
    lang42: "سمعة الأسبوع",
    lang43: "السمعة الشاملة",
    lang44: "ترتيب النادي",
    lang45: "شارك",
    lang46: "إطلاق",
    lang47: "أرسل دعوة للنادي",
    lang48: "قم بإطلاق FIREFLY للاستمتاع بمزيد من البث المباشر",
  },

  /* 珍愛值記錄 */
  treasureRecord: {
    recordTitle2: "اعتزاز بسجل القيمة",
    income10: "الشهر الجاري",
    income11: "الشهر السابق",
    news7: "الأمور",
    news13: "Fan Value",
    cashreal6: "إلغاء",
    box1: "لا يوجد سجلات حتى الآن",
  },

  /* 俱乐部说明页 */
  groupIntruduction: {
    lang1: "مقدمة النادي",
    lang2:
      "النادي عبارة عن مجموعة مكونة من المشجعين الأساسيين للمذيع. من خلال الانضمام إلى النادي، يمكنك المشاركة في الأحداث والمسابقات الممتعة معًا، وتكوين صداقات مع أعضاء في نفس النادي. عدد مجموعات المعجبين والسمعة هي النقاط التنافسية الرئيسية للنادي، كما أنها ترمز إلى نفوذ وشعبية المذيع المؤسس.",
    lang3: "مقدمة عن السمات المتخصصة للنادي",
    lang4: "منشئ C.by:",
    lang5:
      "مؤسس النادي، وعادة ما يكون المذيع. سيفتح المذيع النادي بعد أن يصل عدد الأشخاص الذين يتابعهم إلى عدد معين.",
    lang6: "رئيس P.by:",
    lang7:
      "سيصبح مدير النادي ساري المفعول بعد تعيينه من قبل المضيف. يصبح رئيس النادي أيضًا مدير غرفة البث المباشر لمنشئ C.by.",
    lang8: "العضو:",
    lang9:
      'أعضاء النادي. طريقة الانضمام هي إرسال هدية "نعتز بك" أو "نعتز معًا" أثناء البث المباشر. لا يوجد حد لعدد الأعضاء في أي نادي.',
    lang10: "هدايا حصرية:",
    lang11:
      "مسابقات النادي مع الهدايا المتخصصة. أرسل هدايا النادي لكسب نقاط النادي.",
    lang12: "نقاط النادي:",
    lang13:
      "1. أرسل هدايا حصرية للنادي في غرفة البث المباشر لمؤسس النادي لتجميع نقاط النادي. 2. أكمل مهام النادي اليومية في غرفة البث المباشر لمؤسس النادي لتجميع نقاط النادي.",
    lang14: "السمعة:",
    lang15:
      "مجموع نقاط النادي لجميع الأعضاء في نفس النادي هو سمعة النادي. مجموع نقاط النادي التي يزيدها جميع الأعضاء في النادي كل أسبوع هو سمعة النادي الأسبوعية.",
    lang16: "مستوى العضو",
    lang17:
      "1. عملية تجميع نقاط النادي هي عملية إكمال الترقية. يرجى الرجوع إلى الرمز أعلاه للحصول على التفاصيل. 2. إرسال هدايا النادي. 1 جوهرة = 1 نقطة نادي (لا يؤثر على السمات الأخرى للهدية). 3. لن تزيد نقاط النادي بعد أن تصل إلى الحد الأعلى في اليوم.",
    lang18: "تخفيض مستوى العضوية",
    lang19:
      "1. في النادي، عندما لا يساهم العضو بأي نقاط نادي لمدة 3 أيام متتالية، تبدأ نقاط النادي في التناقص من اليوم الرابع. 2. سيؤدي الانخفاض المستمر لنقطة النادي إلى خفض مستوى العضو. يرجى الرجوع إلى مستوى العضو للحصول على التفاصيل. 3. إذا انخفضت نقاط النادي إلى 0، فسوف يغادر العضو النادي تلقائيًا.",
    lang20: "امتيازات العضوية",
    lang21: "آخر",
    lang22:
      "إذا كان لدى النادي حسابات مزيفة أو غش أو لديه اسم أو غلاف ينتهك القوانين واللوائح المحلية، فإن منصة FIREFLY لها الحق في تعديل النادي أو حذفه.",
    lang23: "مستوى النادي",
    lang24: "النقاط المطلوبة للترقية",
    lang25: "Daily bonus",
    lang26: "الحد الأقصى لنقاط النادي",
    lang27: "التوهين",
    lang28: "الامتياز",
    lang29: "الوصف",
    lang30: "لوحة اسم النادي",
    lang31: "تحديد مستوى خاص في غرفة البث المباشر لمنشئ C.by",
    lang33: "هدايا حصرية في غرفة البث المباشر لمنشئ C.by",
    lang34: "صندوق الدردشة الحصري",
    lang35: "صندوق دردشة حصري في غرفة البث المباشر لمنشئ C.by",
    lang36: "صندوق كنز النادي",
    lang37:
      "يمكنك الحصول على امتيازات صندوق كنز النادي في غرفة البث المباشر لمنشئ C.by",
    lang38: "Daily bonus",
    lang39:
      "يمكنك إكمال المهام اليومية في غرفة البث المباشر لمنشئ C.by لتلقي حزم الهدايا.",
    lang40: "دردشة الأعضاء",
    lang41:
      "الدردشة مع جميع أعضاء النادي في رسائل خاصة دون أي قيود على الخصوصية",
    lang42: "منعش",
    lang43: "خدمة العملاء",
    lang44: "إغلاق الصفحة",
    lang45: "النادي",
    lang46: "Club",
    lang47:
      "النادي مجتمع خاص يؤسسه اللاعبون واللورد معًا. انضم إلى نادٍ وساهم في سمعته لمساعدته على التنافس على الألقاب والفوز بمكافآت تصنيف حصرية!",
    lang48: "الانتماء إلى النادي",
    lang49:
      "يمكن لكل لاعب تحديد نادٍ واحد كحد أقصى كنادي انتمائه. بعد التحديد، يتغير دورك في ذلك النادي إلى 「عضو」. وتُضاف تلقائيًا إلى نادي انتمائك السمعة المكتسبة من الألقاب (مثل الفوز بالتصنيفات ومسابقات المواهب الليلية) والانتصارات في ألعاب غرف PK.",
    lang50: "الانضمام إلى النادي/مغادرته",
    lang51:
      "ينضم اللاعبون إلى نادي اللورد بإرسال هدية 「جرس تشن شين」 إليه. بعد الانضمام عبر الهدية، يكون دور اللاعب 「ضيفًا」. ويمكن للاعب مغادرة النادي بحرية.",
    lang52: "السمعة",
    lang53:
      "السمعة هي جوهر المنافسة بين الأندية. يساهم جميع من في النادي في سمعته عبر إكمال مهام النادي والتنافس على بطولات فعاليات التصنيف والمشاركة في الألعاب والفوز بها.",
    lang54: "مكافآت النادي",
    lang55:
      "تُرسل المكافآت التي يفوز بها النادي في المنافسات إلى رئيسه. ولا يمكن لنادٍ لم يُعيّن له رئيس استلام مكافآت النادي.",
    lang56: "تصنيف الأندية",
    ranked: "مدرج في التصنيف",
    lang57:
      "يمكن للأندية التي تستوفي الشروط التالية المشاركة في تصنيف FIREFLY Club:",
    lang58: "تغيير اسم النادي",
    lang59: "تغيير صورة غلاف النادي",
    lang60: "تعيين رئيس للنادي",
    lang61:
      "يمكن للأندية التي لم تستوفِ هذه الشروط استقبال اللاعبين وتجميع السمعة كالمعتاد، لكنها لا تستطيع المشاركة في التصنيف.",
    lang62: "أدوار النادي",
    lang63: "Club Role",
    lang64: "اللورد",
    lang65:
      "اللورد هو مؤسس النادي ويرتبط به ارتباطًا وثيقًا. يمتلك صلاحيات إدارة النادي وتعديله، ويمكنه تعيين رئيس له.",
    lang66: "الرئيس",
    lang67:
      "يُعيّنه اللورد، ويمتلك صلاحيات إدارة النادي وتعديله. ويمكنه فتح غرفة PK الخاصة بالنادي.",
    lang68:
      "<span class='highlight-text'>مكافآت النادي: </span>تُرسل جميع المكافآت المخصصة للنادي إلى رئيسه. ولا يمكن لنادٍ لم يُعيّن له رئيس استلام مكافآت النادي.",
    lang69: "الأعضاء",
    lang70:
      "لاعبون انضموا إلى النادي وحددوه ك「نادي انتمائهم」. تُضاف مكافآت السمعة التي يحصلون عليها من الألقاب والألعاب تلقائيًا إلى نادي انتمائهم.",
    lang71: "الضيف",
    lang72: "لاعبون انضموا إلى النادي لكنهم لم يحددوه ك「نادي انتمائهم」.",
    lang73: "النادي البطل",
    lang74:
      "يصبح الفائز بتصنيف الأندية الأسبوعي في FIREFLY 「النادي البطل」 للأسبوع التالي. خلال هذه الفترة، لا يمكن للضيوف تحديد النادي البطل كنادي انتمائهم. ويظهر اسم النادي لأعضائه في جميع غرف البث المباشر.",
    lang75: "المزيد",
  },

  /* 极速狂飙 */
  kingOfSpeed: {
    lang1: "قواعد اللعبة",
    lang2: "وصف اللعبة",
    lang3:
      "1. ارمِ النرد: كل نقرة على مِ النرد تكلف 1000 نقطة. يمنح رمي النرد مكافآت لسيارة الفريق.",
    lang4:
      "2. احتمالية النرد: احتمالية سحب كل من التأثيرات الستة متساوية، لكن تأثيرات المكافأة على كل جانب من الجوانب الستة مختلفة.",
    lang5:
      "٣. نتيجة اللعبة: في نهاية وقت ركلات الترجيح، يفوز الفريق ذو المسافة الأكبر، ويخسر الفريق ذو المسافة الأقل. إذا كانت المسافة متساوية بين الفريقين، تكون النتيجة تعادلاً.",
    lang6: "وصف السيارة",
    lang7:
      "1. متطلبات السيارة: إذا لم يكن لدى المذيع سيارة في بداية اللعبة، فلن يمكن تشكيل سيارة الفريق الحالي.",
    lang8: "وصف مستوى تشي",
    lang9:
      "1. رفع المستوى: يتفاعل اللاعبون مع بعضهم البعض لزيادة شعبية المذيع. تُستخدم الشعبية لزيادة مستوى Qi للفريق. كلما ارتفع مستوى Qi، زاد تأثير مكافأة النرد.",
    lang10: "2. متطلبات مستوى تشي:",
    lang11: "مستوى النرد",
    lang12: "الشعبية",
    lang13: "وصف مجموعة DEWs",
    lang14:
      "١. مجموعة الندى: تتراكم نقاط الندى الناتجة عن رمي النرد من كلا اللاعبين في مجموعة الندى. في نهاية اللعبة، سيحصل الفريق الفائز على جميع نقاط الندى في المجموعة كمكافأة. في حالة التعادل، سيحصل لاعبو كلا الفريقين على مكافآت من مجموعة الندى.",
    lang15:
      "٢. توزيع المكافآت: تُوزع المكافآت بناءً على نسبة الندى من رمية النرد لكل لاعب على الفريق الفائز. اللاعبون الذين لم يرموا النرد للمشاركة في اللعبة لا يشاركون في توزيع مكافآت مجموعة الندى.",
    lang16:
      "3. رسوم الخدمة: يحصل اللاعبون على مكافآت من DEWs Pool. ستفرض المنصة رسوم خدمة بنسبة 4%.",
    lang17: "ملاحظات تطوير اللعبة",
    lang18:
      "١. يمكن للاعبين المشاركة في ملك السرعة من خلال PKs داخل اللعبة من الساعة ١٢:٠٠ ظهرًا يوم ٢٠ أكتوبر ٢٠٢٥ إلى الساعة ١٢:٠٠ صباحًا يوم ١٨ نوفمبر ٢٠٢٥.",
    lang19: "احتياطات",
    lang20: "١. جميع الأوقات خلال الحدث تعتمد على وقت الخادم.",
    lang21:
      "٢. لضمان نزاهة اللعبة، تحتفظ المنصة بالحق في تعديل أو تعليق أي مخالفات في اللعبة بسبب عوامل القوة القاهرة، مثل مشاكل الشبكة، أو الغش، أو أي أنشطة غير مصرح بها.",
    lang22:
      "٣. هذه اللعبة لأغراض ترفيهية فقط. يُمنع منعًا باتًا إجراء أي معاملات بين اللاعبين أو المذيعين دون اتصال بالإنترنت. احذر من عمليات الاحتيال أو محاولات الحصول على منافع غير مشروعة.",
    lang23:
      "4. المنصة غير مسؤولة عن أي خسائر في اللعبة ناتجة عن مشاكل في الشبكة أو الجهاز الشخصي.",
    lang24: "5. تحتفظ المنصة بحق التفسير النهائي للعبة.",
    lang25: "سجلات لعبة PK",
    lang26: "وقت PK",
    lang27: "رمي النرد",
    lang28: "فريق PK",
    lang29: "المسافة",
    lang30: "النتائج",
    lang31: "جاري التحميل...",
    lang32: "لا مزيد من السجلات",
    lang33: "لا توجد سجلات ركلات ترجيح في اللعبة",
    lang34: "المذيع الآخر لا يملك سيارة.",
    lang35: "الفريق الأزرق لا يملك سيارة",
    lang36: "الفريق الأحمر ليس لديه سيارة.",
    lang37: "حد السرعة إلى",
    lang38: "السرعة",
    lang39: "يجب على المذيع الحصول على سيارة للانضمام إلى اللعبة.",
    lang40: "المغادرة",
    lang41: "Tips",
    lang42: "لا يملك سيارة حاليًا، لذا لا يمكنه المشاركة في لعبة PK",
    lang43: "انتقل إلى",
    lang44: "مجموعة DEWs",
    lang45: "فريقنا",
    lang46: "الفريق المُقابل",
    lang47: "رمي",
    lang48: "رميتي:",
    lang49: "الجائزة معلومات",
    lang50: "١. مجموعة الندى:",
    lang51:
      "ستُضاف نقاط DEWs من رمي النرد من كلا اللاعبين إلى مجموعة DEWs. في نهاية اللعبة، سيحصل الفريق الفائز على جميع نقاط DEWs في مجموعة DEWs كمكافأة. في حالة التعادل، كلا اللاعبين",
    lang52: "2. توزيع المكافآت:",
    lang53:
      "تُوزّع المكافآت بناءً على نسبة نقاط DEW من رمية النرد لكل لاعب على الفريق الفائز. اللاعبون الذين لم يرموا النرد للمشاركة في اللعبة لا يشاركون في توزيع مكافآت DEWs Pool.",
    lang54: "3. رسوم الخدمة:",
    lang55:
      "يحصل اللاعبون على مكافآت من مجموعة الندى، وستفرض المنصة رسوم خدمة بنسبة ٤٪.",
    lang56: "تم",
    lang57: "زيادة السرعة",
    lang58: "الدرع",
    lang59: "شحنة",
    lang60: "الفريق الأحمر",
    lang61: "الفريق الأزرق",
    lang62: "تفاصيل سيارة السباق",
    lang63: "جاري التفعيل",
    lang64: "لم يقم بالتشغيل بعد",
    lang65: "ثانيا",
    lang66: "سرعة مضاعفة، مستمرة",
    lang67: "الحماية",
    lang68: "غير محمي",
    lang69: "توفر الدروع مقاومة للتأثيرات السلبية مرة واحدة.",
    lang70: "(تداخل، حد السرعة)",
    lang71: "يتبع",
    lang72: "جاري التفعيل",
    lang73: "لم يقم بالتشغيل بعد",
    lang74: "عند اكتمال قيمة الشحن، تكون سرعة السيارة 3 أضعاف، والمدة هي",
    lang75: "مدة زيادة السرعة",
    lang76: "تسريع",
    lang77: "وضع التوربو:",
    lang78: "مدة الدرع",
    lang79: "التداخل",
    lang80: "وضع التداخل:",
    lang81: "حد السرعة",
    lang82: "مكاسب السيارة",
    lang83:
      "قيمة الشحن: عند وصول قيمة الشحن إلى 100%، يُفعّل وضع الشحن. سرعة الشحن هي 3 أضعاف، والمدة هي",
    lang84: "اخرج بعد انتهاء الوقت.",
    lang85: "وضع الشحن",
    lang86: "إعادة ضبط الشحن",
    lang87: "تحصل السيارات على دفعة سرعة.",
    lang88: "مستمر",
    lang89: "ستُستعاد السرعة بعد انتهاء الوقت.",
    lang90: "حصلت سيارة السباق على",
    lang91: "مكافأة",
    lang92: "السرعة",
    lang93: "مستمر",
    lang94: "مقاومة مرة واحدة",
    lang95: "تأثير سلبي",
    lang96:
      "عند منح مكافآت دروع متعددة، تتراكم الدروع. بعد انتهاء الوقت أو تطبيق الحصانة، تقل قيمة الدرع بمقدار 1.",
    lang97: "يستخدم تأثير تعطيل يستهدف الخصم.",
    lang98: "تدخل",
    lang99: "بعد تفعيله، ستنخفض سرعة السيارة العادية.",
    lang100:
      "استخدم تأثير حد السرعة لإرسال إشارة إبطاء للخصم، مما يُبطئ سيارته.",
    lang101: "التداخل",
    lang102: "حد السرعة",
    lang103: "رمي النرد",
    lang104: "ارمِ النرد للحصول على مكافآت.",
    lang105: "التسارع! الركض معًا!",
    lang106: "تم نسخ الشعار. يُرجى لصقه في مربع الإدخال وإرساله!",
    lang107: "فشل النسخ",
    lang108: "شارك في لعبة السباق",
    lang110: "يمتلك المذيع سيارة.",
    lang111: "تم الإنجاز",
    lang112: "لم يتم تحقيقها",
    lang113: "انضم إلى فريق ركلات ترجيح",
    lang115: "انقر لإرسال سيارة",
    lang116: "انقر لإرسال شعار الفريق",
    lang117: "اللعبة الحالية غير مُفعّلة، لذا لا يُمكن رمي النرد.",
    lang118: "لا يُسمح للمذيع برمي النرد.",
    lang119: "اندفاع السرعة، الفائز يربح كل شيء!",
    lang120: "لم تبدأ اللعبة",
    lang121: "[ملك السرعة] غير مُفعّل ولا يُمكن لعبه.",
    lang122: "سباق للحصول على مكافأة الدرع",
    lang123: "لا مقعد",

    lang124: "رائدة",
    lang125: "تخلف",
  },

  /* 上播助手 */
  videoAssistant: {
    lang1: "مساعد مباشر",
    lang2:
      "إذا كنتَ لاعبًا مقيدًا كمساعد مباشر، فسيحصل اللاعب على حصتك من نقاط FIRE التي حصلتَ عليها.",
    lang3: "مساعد مباشر مقيد",
    lang4: "أدخل المُعرِّف لتأكيد اللاعب المقيد.",
    lang5: "أدخل معرف اللاعب الذي تريد ربطه",
    lang6: "الخطوة التالية",
    lang7: "نسبة حصة FIREs",
    lang8: "تعليمات الربط",
    lang9:
      "بعد ربط مساعدك المباشر، سيستلم مساعدك المباشر حصة من نقاط FIRE التي تجمعها. سيتم إرسال نقاط FIRE التي تجمعها من خلال الهدايا إلى مساعدك المباشر وفقًا لنسبة حصة نقاط FIRE التي حددتها.",
    lang10: "تم",
    lang11: "ربط مساعدك المباشر",
    lang12: "تأكيد الربط؟",
    lang13: "مساعدك المباشر",
    lang14: "إلغاء",
    lang15: "تم الربط بنجاح",
    lang16: "فشل الربط",
    lang17: "تم فك الارتباط بنجاح",
    lang18: "فشل فك الارتباط",
    lang19:
      "إذا كنتَ لاعبًا مقيدًا كمساعد مباشر، فسيحصل اللاعب على حصتك من نقاط FIRE التي حصلتَ عليها.",
    lang20: "مساعدي المباشر",
    lang21: "فك الارتباط",
    lang22: "في انتظار التأكيد",
    lang23: "فك ارتباط مساعدك المباشر",
    lang24:
      "يتطلب فك الارتباط من مساعد مباشر تأكيدًا من الطرف الآخر. هل تريد فك الارتباط؟",
    lang25: "مساعدك المباشر؟",
    lang26: "تم رفض فك الارتباط",
    lang27: "رفض فك الارتباط، فشل",
    lang28: "إعدادات مساعدك المباشر",
    lang29: "\u200f الحصول على FIREs\u200f",
    lang30: "قام الطرف الآخر بفك ارتباطك بمساعدك المباشر؛ يتطلب تأكيدك.",
    lang31: "طلب فك الارتباط",
    lang32: "تم تطبيق العكس على إلغاء ربط حساب مساعدك المباشر. يرجى التأكيد.",
    lang33: "رفض",
    lang34: "قائمة المُذيعين الذين ربطوني كمساعد مباشر",
    lang35: "لم يتم ربط أي لاعبين بعد",
    lang36: "فك ارتباط مساعدك المباشر",
    lang37: "هل تريد فك الارتباط؟",
    lang38: "ما هي علاقتك بمساعد مباشر؟",
    lang39: "لقد تم حظر المستخدم.",
    lang40: "لقد فشل البحث عن المعرف الذي أدخلته.",
  },

  /* 夜间选秀 */
  nightDraft: {
    lang2: "حالة البث المباشر",
    lang3: "تاريخية",
    lang4: "لقد انسحبتَ من مشاركة اليوم",
    lang5: "لم يتم الانسحاب من المشاركة اليوم",
    lang6: "انسحاب من المشاركة",
    lang7: "رتبتي",
    lang8: "انتصارات",
    lang9: "تعليمات المسابقة",
    lang10:
      "يجب على المذيعين الذين يتأهلون إلى نصف النهائي/النهائيات أن يكونوا على الهواء مباشرة وألا يكونوا حاليًا في مباراة PK أخرى في وقت البدء المحدد. سيبدأ النظام تلقائيًا مباراة PK بين المذيعين المعنيين.",
    lang11: "نصف النهائي",
    lang12: "نظام الأفضل من 5، يتأهل المذيع الفائز إلى النهائيات.",
    lang13: "اختبار الأداء رقم 1 ضد اختبار الأداء رقم 4",
    lang14: "اختبار الأداء رقم 2 ضد اختبار الأداء رقم 3",
    lang15: "النهائيات",
    lang16:
      'نظام الأفضل من 5، يصبح المذيع الفائز بطل "Glow Night Showdown" لهذا اليوم.',
    lang17: "الفائز في نصف النهائي",
    lang18:
      "ملاحظة: إذا كنت تستوفي شروط المشاركة في نصف النهائي/النهائيات ولكنك لا تستطيع الانضمام، يُرجى الضغط هنا قبل الساعة 8:30 مساءً يوميًا.",
    lang20:
      'الغياب عن المباراة سيؤدي إلى عدم القدرة على المشاركة في حدث "مواجهة ليلة التوهج" لمدة 15 يومًا.',
    lang22:
      "سيؤدي انسحابك من المباراة إلى إزالتك من تصنيف Audition، وستُعاد أهليتك في اليوم التالي.",
    lang23: "هل ترغب في الانسحاب من مشاركة اليوم؟",
    lang24: "فعالية مواجهة ليلة التوهج الناري",
    lang25: "إلغاء",
    lang26: "تم",
    lang27: "انتصارات",
    lang28: "لم يُكمل",
    lang29: "لا توجد سجلات سابقة متاحة",
    lang30: 'شارك في "Glow Night Showdown".',
    lang31:
      'المذيعون الذين يستخدمون FIREFLY الإصدار 54.0 أو أعلى لبدء PK (بما في ذلك "Popularity PK" و"Game PK") مؤهلون للمشاركة في حدث Glow Night Showdown.',
    lang32: "اختبار الأداء",
    lang33: "الوقت: يوميًا من 20:30 - 20:30 من اليوم التالي",
    lang34:
      "القاعدة: ابدأ مباراة PK مع مذيع سبق له الحصول على «اعتماد النجم الصاعد» للمشاركة في ترتيب اختبار الأداء لذلك اليوم. يُحدَّد الترتيب بناءً على مجموع قيم الشعبية لجميع مباريات PK التي أكملها المذيع في ذلك اليوم.",
    lang35:
      "التقدم: يتأهل أفضل ٤ مُذيعين في ترتيب الاختبار بحلول الساعة ٢٠:٣٠ مساءً يوميًا إلى نصف النهائي.",
    lang36:
      "انسحاب المشاركة: إذا لم يتمكن المذيع من البث المباشر خلال الوقت المحدد لنصف النهائي/النهائيات، فيمكنه اختيار الانسحاب خلال فترة تجارب الأداء. وسيحل محله المذيع التالي في الترتيب.",
    lang37: "نصف النهائي",
    lang38: "الوقت: يوميًا الساعة ٢١:٠٠ / ٢١:٢٠ مساءً",
    lang39:
      'القاعدة: سيبدأ النظام تلقائيًا مباراة ركلات الترجيح بين مُذيعي نصف النهائي في الوقت المُحدد. قاعدة ركلات الترجيح هي "ركلات الترجيح حسب الشعبية" بنظام أفضل من ٥. يجب على المذيعين البقاء على الهواء خلال هذه الفترة.',
    lang40: "التأهل: يتأهل الفائز إلى النهائيات.",
    lang41:
      'انسحاب المشاركة: يُعتبر المذيع منسحبًا إذا لم يكن مباشرًا في بداية نصف النهائيات. لن يحصلوا على مكافآت التصنيف ولن يكونوا مؤهلين للمشاركة في "مواجهة ليلة التوهج" لمدة 15 يومًا.',
    lang42: "يتم تحديدها عبر سحب قرعة عشوائي من النظام بعد انتهاء التصفيات اليومية",
    lang43: "يتم تحديدها عبر سحب قرعة عشوائي من النظام بعد انتهاء التصفيات اليومية",
    lang44:
      "سيتم تصنيف الخاسرين في نصف النهائي في المركزين الثالث والرابع بناءً على أعلى قيمة شعبية لهم في اليوم.",
    lang45: "النهائيات",
    lang46: "الوقت: يوميًا الساعة ١٠:٠٠ مساءً",
    lang47:
      'القاعدة: سيبدأ النظام تلقائيًا مباراة PK بين المذيعين المتأهلين للنهائيات في الوقت المحدد. قاعدة PK هي "مباراة PK الشعبية" بنظام الأفضل من 5. يجب على المذيعين البقاء على الهواء خلال هذا الوقت.',
    lang48: 'التقدم: يُتوّج الفائز بطلًا لـ "مواجهة ليلة التوهج" لهذا اليوم.',
    lang49:
      'انسحاب من المشاركة: يُعتبر المذيع منسحبًا إذا لم يكن مباشرًا في بداية النهائيات. لن يحصل على مكافآت التصنيف ولن يكون مؤهلًا للمشاركة في "مواجهة ليلة التوهج" لمدة 15 يومًا.',
    lang50: "الفائز في النهائيات هو بطل اليوم، والخاسر هو صاحب المركز الثاني.",
    lang51: "جائزة",
    lang52: "مكافأة DEWs للاعبين:",
    lang53: "نصف النهائي 1: يتقاسم الفريق الفائز النقاط.",
    lang54: "نصف النهائي ٢: سيُقسّم الفريق الفائز",
    lang55: "النهائيات: يتقاسم الفريق الفائز النقاط.",
    lang56: "مكافأة نقاط المذيع:",
    lang57:
      'بعد تحديد الفائز، سيحصل المذيعون المشاركون في نصف النهائي/النهائيات على نقاط "مكافأة البث المباشر". أما المذيعون الذين ينسحبون، فلن يحصلوا على نقاط. يُرجى مراجعة النقاط المحددة هنا.',
    lang58: "مكافآت البث المباشر >",
    lang59: "احتياطات",
    lang60: "1. الحدث يقتصر على المذيعات الإناث",
    lang61:
      "2. خلال فترة تقييد أهليتك للمشاركة في النشاط، ستكون جميع بيانات النشاط غير صالحة ويجب الحصول عليها مرة أخرى بعد رفع الحظر.",
    lang62:
      '3. يجب على مقدمي البث التفاعل بفعالية مع اللاعبين. تحتفظ المنصة بحقها في استبعاد مقدمي البث وسحب نقاط نشاطهم في حال مخالفة "اتفاقية البث" أو الإخلال بتوازن الفعالية (بما في ذلك على سبيل المثال لا الحصر: البث المباشر الذي يكشف الوجه، والبث بجودة منخفضة، والشاشات السوداء، والبث المباشر أثناء عدم التواجد، والبث أثناء اللعب، ومشاهدة التلفاز، والتواطؤ في نتائج مباريات لاعب ضد لاعب، واللعب السلبي). سيخضع مقدمو البث الذين يخالفون القواعد المذكورة أعلاه لعقوبة "البطاقة الحمراء" من قبل المنصة.',
    lang63: "4. تحتفظ المنصة بحق التفسير النهائي لهذا الحدث.",
    lang64: "في مرحلة الاختبار",
    lang65: "20:30 - 20:30 من اليوم التالي",
    lang66:
      "ابدأ PK مع مذيع للمشاركة في تصنيف Audition. تجمع لوحة تصنيف Audition قيم الشعبية من مباريات PK الصالحة خلال اليوم، ويتأهل أصحاب المراكز الأربعة الأولى إلى نصف النهائي.",
    lang67: "منطقة الترويج",
    lang68: "لا توجد سجلات تجارب أداء متاحة.",
    lang69: "FIREFLY لقد حجزتَ مكانًا في نهائيات Glow Night Showdown.",
    lang70:
      "يوميًا، من الساعة 9 مساءً حتى 11 مساءً، يحصل الفائزون في PK على مكافآت DEWs.",
    lang71: "المذيع المتأهل للنهائيات: لم يتم تحديده.",
    lang72: "لم يتم تحديد مذيعي نصف النهائي",
    lang74: "اختبار الأداء رقم 1",
    lang75: "اختبار الأداء رقم 2",
    lang76: "اختبار الأداء رقم 3",
    lang77: "اختبار الأداء رقم 4",
    lang78: "تذكير >",
    lang79: "مكافأة الفريق الفائز",
    lang80: "أفضل من ٥",
    lang81: "الترتيب مغلق",
    lang82: "لا يوجد تصنيف بعد",
    lang83:
      "'FIREFLY' لقد حجزت الدور نصف النهائي في برنامج المواهب الليلية الفلورية.",
    lang84:
      "'FIREFLY' لقد حجزت الدور نصف النهائي الثاني من برنامج المواهب الليلية الفلورية",
    lang85: "جارٍ تحميل المزيد...",
    lang86: "قم بالتمرير لأسفل لتحميل المزيد",
    lang87: "لا توجد معلومات أخرى متاحة.",
    lang88: "عقوبة البطاقة الحمراء:",
    lang89:
      'أ. إلغاء الأهلية لتلقي المكافآت الخاصة بـ "عرض التوهج الليلي" في ذلك اليوم.',
    lang90:
      'ب. يُحظر عليك المشاركة في فعالية "اختبار الأداء الليلي النيون" خلال الأيام الخمسة القادمة.',
    lang91: "مكافأة",
    lang92:
      "سيحصل أفضل 4 مذيعين في 'الاختبار الليلي الفلوري' اليومي على مكافآت",
    lang93: "البطل",
    lang94: "رقم 2",
    lang95: "رقم 3/رقم 4",
    lang96: "مراتب أخرى",
    lang97: "لا توجد مكافأة",
    lang98: "تم الاستلام",
    lang99: "لم يتم الحصول على مكافأة الاختبار الليلي الفلوري",
    lang100: "استلام",
    lang101: "لقد استلمت مكافأة الاختبار الليلي الفلوري",
    lang102: "تم الاستلام بنجاح",
    lang103: "يمكن للمذيعين الحصول على مكافآت الجواهر:",
    lang104: "البطل:",
    lang105: "المركز الثاني:",
    lang106: "المركز الثالث/الرابع:",
    lang107: "جوائز النهائيات",
    lang108: "النتائج",
    lang109: "مكافأة",
    lang110: "فوز",
    lang111: "خسارة",
    lang112: "غير مكتمل",
    lang123: "لا توجد مكافأة",
    lang124: "جوائز نصف النهائي",
    lang125: "جوائز التصفيات",
    lang126: "جوائز النهائيات",
    lang127:
      'شارك في نهائيات "اختيار الليل الفسفوري"، ويمكن المطالبة بالمكافآت بعد انتهاء النهائيات.',
    lang128: "جوائز نصف النهائي",
    lang129:
      'شارك في نصف نهائيات "اختيار الليل الفسفوري"، ويمكن المطالبة بالمكافآت بعد انتهاء النهائيات.',
    lang130: "جوائز التصفيات",
    lang131:
      'يمكن للأوائل الثمانية في نهائيات "اختيار الليل" المطالبة بالمكافآت، وتوزع يوميًا في الساعة 21:00.',
    lang132: "لم يبدأ",
    lang133: "في PK",
    lang134: "انتهى",
    lang135: "لا توجد مكافآت متاحة للمطالبة بها",
    lang136: "لقد قمت بالفعل بالمطالبة بالمكافأة",
    lang137: "شارك في PK لاختيار الليل الفسفوري، واربح ",
    lang138: "مطالبة",
    lang139: "تمت المطالبة",
    lang140: "المطالبة بالكل",
    lang141: "مكافآتي",
    lang142: "متوسط",
    lang143: "NO.1-NO.4",
    lang144: "ترتيب التصفيات",
    lang145: "NO.5-NO.8",
    lang146: "لا توجد مكافأة",
    lang147: "ترتيبات أخرى",
    lang148: "لم يشارك",
    lang149: "منطقة المكافآت",
    lang150: "يرجى تحديث التطبيق إلى الإصدار V57.0 أو أعلى للمطالبة بالمكافآت",
    lang151: "نتيجة المرحلة",
    lang152:
      "يمكن المطالبة بها بعد تحديد الترتيب النهائي لفعالية Night Draft اليوم",
    lang153: "أفضل 4 في التصفيات",
  },

  /* firstLove */
  firstLove: {
    lang1: "FirstLove",
    lang2:
      'اللاعبون الجدد الذين يسجلون خلال 7 أيام، أكمل نشاط "حزمة الشحن الأول" للحصول على جائزة هدية "FirstLove". بعد إرسال هدية "FirstLove"، سيتم ربط المذيع بـ FirstLove، وسيظهر ملصق خاص عند التعليق في غرفة البث المباشر. يمكن لكل لاعب ربط FirstLove واحد فقط.',
    lang3: 'مدخل "حزمة الشحن الأول"',
    lang4: "إرسال هدية من الحقيبة",
    lang5: "تصنيف هدية FirstLove الأولى",
    lang6:
      "يتم ترتيب تصنيف هدية FirstLove الأولى بناءً على عدد هدايا FirstLove الأولى التي يتلقاها المذيعون. كلما زاد العدد، ارتفع الترتيب. وإذا تلقى عدة مذيعين العدد نفسه من هدايا FirstLove،",
    lang7: "فإن المذيع الذي يصل إلى هذا العدد أولاً يكون ترتيبه أعلى.",
  },

  /* 迎新奖励 */
  newsRewards: {
    lang1: "مكافأة يومية",
    lang2: "سجل المكافآت",
    lang3: "مهمة الترحيب",
    lang4: "نقاط",
    lang5: "أكمل «PK الترحيب»، يمكنك الحصول على 6000 نقطة كحد أقصى يوميًا",
    lang6: "PK الترحيب",
    lang7:
      "بكل إكمال جولة واحدة من «PK الترحيب» (60 دقيقة)، احصل على مكافأة النقاط بناءً على نتيجة PK",
    lang8: "جولة",
    lang9: "تم الحصول",
    lang10: "استلام",
    lang11: "تم الاستلام",
    lang12: "تبادل النقاط",
    lang13: "نقاطي",
    lang14: "مكافأة",
    lang15: "مستوى",
    lang16: "النقاط التراكمية تصل إلى",
    lang19: "مكافأة النقاط",
    lang20: "مكافأة الترحيب",
    lang21: "بدء PK الترحيب يوميًا، دعم حركة المرور الحصرية",
    lang25: "إعجاب",
    lang26: "لا توجد بيانات",
    lang27: "قواعد مكافأة الترحيب",
    lang28: "PK الترحيب",
    lang29:
      "عند بدء PK، يختار مذيع الترحيب «PK الترحيب» ويبدأ المطابقة. PK الترحيب يقارن عدد الإعجابات بين المذيعين.",
    lang30: "طرق الحصول على الإعجابات:",
    lang31: "الحصول على هدايا حصرية للاعبين الجدد",
    lang32: "شرح الهدية الحصرية:",
    lang33: "اسم الهدية:",
    lang34: "طريقة الحصول:",
    lang35:
      "اللاعبون المسجلون حديثًا يحصلون مجانًا على هذه الهدية، صلاحيتها 48 ساعة. يمكن النقر على «هدية الترحيب» في غرفة البث المباشر لاستلامها.",
    lang36: "إعجاب",
    lang37: "FirstLove",
    lang38:
      "اللاعبون الجدد الذين يسجلون خلال 7 أيام، أكمل نشاط «حزمة الشحن الأول» للحصول على جائزة هدية «FirstLove».",
    lang39: "لقد استلمت بالفعل نقاط اليوم",
    lang40: "لم تصل إلى متطلبات المكافأة، لا يمكن استلام النقاط",
    lang41: "تم استلام نقاط مكافأة الترحيب بنجاح",
    lang42: "دعم حركة المرور للترحيب",
    lang43:
      "بدء «PK الترحيب»، ستحصل على دعم حركة المرور للترحيب. اللاعبون المسجلون حديثًا خلال PK الترحيب سيتم دفعهم بنشاط إلى غرفة البث المباشر لـ «PK الترحيب».",
    lang44: "استلام النقاط",
    lang45:
      "أكمل «المكافأة اليومية» لكسب النقاط، عند وصول النقاط التراكمية إلى المستوى المقابل، يمكنك استلام مكافأة اليراعات",
    lang46: "ملاحظات",
    lang47: "1. النشاط متاح فقط للمذيعات الإناث",
    lang48:
      "3. كل جهاز محدود بحساب واحد للاستلام، سيتم إلغاء أهلية النشاط للحسابات المتعددة ولن يتم استعادتها",
    lang49:
      "4. أثناء فترة تقييد أهلية المشاركة في النشاط، جميع بيانات النشاط غير صالحة، يجب إعادة الحصول عليها بعد رفع القيد",
    lang50:
      "5. نقاط «المكافأة اليومية» يجب استلامها بنفسك، يرجى الاستلام قبل 2025/12/03 12:00، لن يتم تعويضها بعد انتهاء الصلاحية",
    lang51:
      "6. الحسابات المرتبطة بداعٍ مسموح لها بفتح حسابات إضافية للبث المباشر واستلام النقاط، عند الاكتشاف سيتم إلغاء أهلية جميع الحسابات ولن يتم استعادتها",
    lang52:
      "7. الحسابات غير المرتبطة بداعٍ غير محدودة بحسابات إضافية، تمنح أهلية المشاركة حسب الحالة، ولكن يمكن فقط اختيار حساب واحد للمشاركة في نشاط المكافآت",
    lang53:
      "8. يجب على المذيعين التفاعل بنشاط مع اللاعبين، أي انتهاك لـ «اتفاقية بث المذيع» أو سلوك يضر بتوازن النشاط، للمنصة الحق في إلغاء أهليته في النشاط ونقاط النشاط (بما في ذلك على سبيل المثال لا الحصر: بث بدون وجه، بث بدون جودة، شاشة سوداء، وضع البث، بث ألعاب، مشاهدة التلفاز، إلخ)",
    lang54: "9. الحق النهائي في تفسير النشاط يعود للمنصة",
    lang55: "2. مدة النشاط تُحصّل كل دقيقتين",
    lang57: "فوز",
    lang58: "تعادل",
    lang59: "خسارة",
    lang60: "مكافأة المستوى الأول",
    lang61: "مكافأة المستوى الثاني",
    lang62: "مكافأة المستوى الثالث",
    lang63: "مكافأة المستوى الرابع",
    lang64: "مستوى المكافأة",
    lang65: "متطلبات النقاط",
    lang66: "النقاط تصل إلى",
    lang67: "قابل للاستلام",
    lang68: "تبادل النقاط بنجاح",
    lang69: "إعجاب",
    lang70: "إعجاب",
    lang71: "لقد استلمت بالفعل نقاط اليوم",
  },

  /* 合作联系 */
  cooperate: {
    lang1: "تم إرسال رسالتك بنجاح!",
    lang2: "لقبك",
    lang3: "وسيلة الاتصال:",
    lang4: "معلومات الاتصال:",
    lang5:
      "شكرًا جزيلاً على رسالة التعاون واقتراحاتك لنمو FIREFLY. سيتصل بك موظفونا. يرجى الانتباه إلى معلومات الاتصال التي تركتها.",
    lang6: "مقدمة تعاون المضيف",
    lang7: "عرض الصفحة الرئيسية للمبعوث",
    lang8: "العودة إلى الصفحة الرئيسية",
    lang9:
      "يمكن لمضيفي FIREFLY أو داعي المستخدمين أو أعضاء النقابة الذين يصبحون مبعوثين إقامة علاقة مراسلة مع الأشخاص الذين يدعونهم والحصول على مكافآت طويلة الأجل. سيحصل المبعوثون المتميزون أيضًا تلقائيًا على امتيازات في المجتمع.",
    lang10: "يرجى ترك معلومات الاتصال الخاصة بك",
    lang11: "يرجى ترك معلومات الاتصال البديلة الخاصة بك (اختياري)",
    lang12: "رسالتك إلى FIREFLY",
    lang13: "يرجى إدخال رسالتك إلى FIREFLY",
    lang14: "تأكيد الإرسال",
    lang15: "حدد وسيلة الاتصال",
    lang16: "Wechat",
    lang17: "تعاون المضيف",
    lang18: "ينضم المضيفون المستقلون إلى FIREFLY بأنفسهم",
    lang19: "تعاون المبعوث",
    lang20: "انضم إلى FIREFLY كنقابة",
    lang21: "تعاون تجاري",
    lang22: "الترويج والإعلام",
    lang23: "تعليقات اللاعبين",
    lang24: "قناة تقديم تعليقات لاعبي FIREFLY",
    lang25: "اتصال التعاون",
    lang26: "يرجى إدخال FIREFLY ID الخاص بك",
    lang27: "يرجى إدخال Whatsapp ID الخاص بك",
    lang28: "يرجى إدخال Telegram ID الخاص بك",
    lang29: "يرجى إدخال Facebook ID الخاص بك",
    lang30: "يرجى إدخال بريدك الإلكتروني",
    lang31: "يرجى إدخال Wechat الخاص بك",
    lang32: "يرجى إدخال Line الخاص بك",
    lang33: "يرجى المحاولة مرة أخرى لاحقًا",
    lang34: "يرجى إدخال لقبك",
    lang35: "يرجى إدخال معلومات الاتصال الخاصة بك",
    lang36: "يرجى إدخال رسالتك",
  },
  premiumNumberCommitLetter: {
    lang1: "خطاب التزام تفعيل الرقم المميز",
    lang2: "عزيزي/عزيزتي ",
    lang3: "المعرف الأصلي: ",
    lang4: "الرقم المميز الذي قدمت طلبًا له ",
    lang5:
      "سيتم تفعيله لك قريبًا. للحفاظ على النظام وأمان الحساب، يرجى قراءة الشروط التالية بعناية والموافقة عليها:",
    lang6:
      "الرقم المميز الذي حصلت عليه مورد نادر وغير متجدد في مجتمع FIREFLY. قد يؤثر نقل هذا النوع من الحسابات سلبًا على استقرار وهيكل المجتمع.",
    lang7: "[شروط الالتزام]",
    lang8:
      "1. أتعهد بأن هذا الرقم المميز مخصص لاستخدامي الشخصي فقط ولن يتم تقديمه لأي طرف ثالث بأي شكل من الأشكال، بما في ذلك البيع أو التأجير أو الهبة أو التحويل.",
    lang9:
      "2. أفهم أنه في حال مخالفة ما سبق، يحق للمنصة سحب الرقم المميز وقد تفرض قيودًا على الحساب الأصلي مثل الحظر أو خفض الامتيازات.",
    lang10:
      "3. أتعهد بالالتزام باتفاقيات المستخدم والقوانين واللوائح ذات الصلة وعدم استخدام الرقم المميز في أي نشاط مخالف أو غير قانوني.",
    lang11: "يصبح هذا الالتزام ملزمًا بمجرد التوقيع. شكرًا لتفهمك وتعاونك.",
    lang12: "لا أوافق",
    lang13: "أوافق",
    lang14: "تمت الموافقة من المستخدم",
    lang15: "وقت الموافقة: ",
    lang16: "تم تقديم طلب النقل",
    lang17:
      "سيتم التواصل معك من قبل خدمة العملاء بشأن وقت النقل المحدد. شكرًا لتفهمك ودعمك.",
    lang18: "حسنًا",
    lang19: "تم تقديم طلبك بنجاح. شكرًا لتفهمك ودعمك.",
    lang20: "تحديث",
    lang21: "خدمة العملاء",
    lang22: "إغلاق الصفحة",
    lang23: "المزيد",
  },
  vipUpPublicNotice: {
    lang1:
      "لتزويدك بتجربة تفاعل أكثر تميزًا وخصوصية، سنطلق رسميًا نظام مستويات VIP الجديد في ",
    lang2: "2026/8/4",
    lang3: "تم إطلاق المستوى الجديد للأثرياء رسميًا",
    lang4:
      "يشمل هذا التحديث تعديل نقاط الثراء المطلوبة لبعض مستويات VIP وإضافة مزايا وامتيازات أكثر ثراءً وروعة. فيما يلي التغييرات الرئيسية:",
    lang5: "بعد إطلاق النظام الجديد، سيتم ",
    lang6: "الوراثة تلقائيًا بناءً على نقاط الثراء",
    lang7: " إلى مستوى VIP المقابل في النظام الجديد.",
    lang8:
      "على سبيل المثال: إذا كان مستواك السابق VIP43 ونقاط الثراء 3254120، فسيتم توريثه إلى VIP45 دون تغيير النقاط وستحصل على الامتيازات المقابلة.",
    lang9: "نوع الامتياز",
    lang10: "تفاصيل الامتياز",
    lang11: "مستوى الفتح",
    lang12: "إخفاء الهوية",
    lang13: "التخفي",
    lang14: "إعفاء الإدارة",
    lang15: "حماية من الطرد وكتم الصوت",
    lang16: "مركبة شخصية",
    lang17: "مركبة حصرية مخصصة",
    lang18: "نظام الأرقام المميزة",
    lang19: "رقم مميز من 6/5/4 أرقام",
    lang20: "رسائل ملونة",
    lang21: "تخصيص 3 ألوان/5 ألوان",
    lang22: "خدمة حصرية",
    lang23: "قناة خدمة عملاء حصرية",
    lang24: "عروض الشحن",
    lang25: "قناة شحن حصرية",
    lang26: "تحسين البطاقة الشخصية",
    lang27: "خلفية بطاقة شخصية ثابتة/متحركة",
    lang28: "هدية مخصصة",
    lang29: "هدية متوسطة (5 ثوان) / متقدمة (10 ثوان)",
    lang30: "إشعار على مستوى الموقع",
    lang31: "إشعار عند الاتصال عبر الموقع",
    lang32: "خلال تطوير المنصة سنعمل على ",
    lang33: "تحسين امتيازات VIP وتجربة الخدمة باستمرار",
    lang34:
      "، وإذا حدثت أي تغييرات في قواعد الامتيازات أو المزايا، فسنصدر إشعارات في الوقت المناسب. يرجى المتابعة.",
    lang35: "تحتفظ Firefly بالحق النهائي في التفسير",
  },
  // Ludo
  ludo: {
    clubPkRoom: "غرفة PK الخاصة بـ {club}",
    lang1: "فتح غرفة",
    lang2: "انضمام سريع",
    lang3: "الدخول",
    lang4: "قيد الانتظار",
    lang5: "لا توجد غرف Ludo PK حاليًا",
    lang6: "وضع اللعب",
    lang7: "النادي الافتراضي",
    lang8: "كلاسيكي",
    lang9: "غير محدود",
    lang10: "السجل",
    lang11: "الترتيب",
    lang12: "ندى الدخول",
    lang13: "معلومات اللعب",
    lang16: "ادفع ندى الدخول للانضمام إلى Ludo PK",
    lang17: "عدد اللاعبين",
    lang18: "مكافآت الفوز",
    lang19: "السمعة",
    lang20: "أدواتي",
    lang21: "القطعة",
    lang22: "اللوحة",
    lang23: "اختر أداة القطعة التي تريد استخدامها في لعبة LUDO.",
    lang24:
      "اختر أداة اللوحة التي سيستخدمها ناديك في غرفة PK الخاصة بلعبة LUDO.",
    lang25: "شارة الوقت",
    lang26: "تم الاختيار",
    lang27: "افتراضي",
    lang28: "يرجى اختيار أداة",
    lang31: "استخدام",
    lang32: "اضغط لاختيار الأداة التي تريد استخدامها",
    lang33: "اضغط للاستخدام، ستستخدم لعبة LUDO التالية أداة اللوحة هذه",
    lang34: "اضغط للاستخدام، ستستخدم لعبة LUDO التالية أداة القطعة هذه",
    lang35: "قيد الاستخدام",
    lang36: "يرجى اختيار الأداة التي تريد استخدامها",
    lang37: "تم الاستخدام بنجاح، وسيصبح ساريًا في لعبة LUDO التالية",
    lang38: "يوم",
    lang39: "ساعة",
    lang40: "دقيقة",
    lang42: "لا توجد سجلات LUDO PK حاليًا",
    lang43: "تفاصيل اللعبة",
    lang45: "رسوم الغرفة",
    lang46: "الوقت",
    lang47: "الندى",
    lang49: "التاريخ",
    lang50: "الإجمالي",
    lang51: "صور اللاعبين",
    lang52: "الترتيب",
    lang53: "المركز 1",
    lang54: "المركز 2",
    lang55: "المركز 3",
    lang56: "المركز 4",
    lang57: "جارٍ التحميل...",
    lang58: "خدمة العملاء",
    lang59: "فوز",
    lang60: "خسارة",
    lang61: "تعادل",
    lang62: "شرح طريقة اللعب",
    lang63: "قواعد اللعبة",
    lang64: "عدد اللاعبين",
    lang66: "تحديد الفوز والخسارة",
    lang68: "سمعة النادي",
    lang69: "المشاركة في اللعبة",
    lang70: "الانضمام أثناء اللعب",
    lang72: "الإقلاع",
    lang73: "ثلاث ستات متتالية",
    lang74: "الحركة",
    lang75: "تكديس القطع",
    lang76: "أكل القطع",
    lang77: "المنطقة الآمنة",
    lang78: "2-4 لاعبين",
    lang79:
      "كلاسيكي: يجب أن تبدأ قطع اللاعب من نقطة البداية وتدور حول اللوحة دورة كاملة ثم تصل إلى النهاية. عندما تصل جميع القطع إلى النهاية تعتبر اللعبة مكتملة. كلما أنهيت اللعبة أسرع كان ترتيبك أعلى.",
    lang80:
      "وفقًا لوضع اللعب، يحصل اللاعب الذي ينهي اللعبة أولًا على ترتيب أعلى. على سبيل المثال، اللاعب الأول الذي ينهي اللعبة يكون صاحب المركز الأول في هذه الجولة، وهكذا.",
    lang81:
      "بعد انتهاء اللعبة، يمكنك الحصول على مكافآت الندى والسمعة حسب ترتيبك.",
    lang82:
      "إذا فزت باللعبة داخل غرفة النادي التي انضممت إليها، فستزداد سمعتك في ذلك النادي وفقًا لترتيبك في اللعبة.",
    lang83: "ادفع ندى الدخول الذي حدده مالك الغرفة للانضمام إلى اللعبة.",
    lang84:
      "في الألعاب التي بدأت بالفعل، يمكن للاعبين دفع ندى الدخول للانضمام إلى Ludo PK في منتصف اللعبة.",
    lang85:
      "يجب أن ترمي النرد وتحصل على الرقم ستة حتى تتمكن القطعة من الإقلاع من القاعدة إلى خانة البداية.",
    lang86:
      "إذا تم رمي الرقم ستة 3 مرات في نفس الدور، فسيتم تفعيل ثلاث ستات متتالية، وسيتجاوز اللاعب هذا الدور.",
    lang87:
      "يرمي اللاعب النرد للحصول على النقاط وتحريك القطعة إلى الأمام بعدد الخطوات المقابل.",
    lang88:
      "إذا توقفت قطع اللاعب نفسه في المكان نفسه فإنها تصبح تكديسًا. وعند أكلها تُعاد جميع القطع المكدسة إلى القاعدة.",
    lang89:
      "إذا توقفت القطعة بعد الحركة على خانة يوجد عليها قطعة لاعب آخر، فسيتم إعادة جميع قطع ذلك اللاعب إلى القاعدة، ويجب أن تقلع من جديد قبل أن تتمكن من الحركة.",
    lang90:
      "القطع التي تقف على نقطة البداية أو على الخانات ذات الدرع على اللوحة لا يمكن أكلها. ويمكن لقطع لاعبين مختلفين التوقف في هذه الخانات في الوقت نفسه.",
    lang91:
      "تُحصَّل في كل لعبة كمية ثابتة من الندى كرسوم للغرفة. ويتم تحديد مبلغ رسوم الغرفة وفقًا لكمية ندى الدخول، ولا يرتبط بعدد اللاعبين. وعند تسوية مكافآت الندى بعد انتهاء اللعبة، سيقوم النظام بخصم رسوم الغرفة تلقائيًا قبل صرف مكافآت الندى للفائز.",
    lang92: "الانضمام إلى اللعبة",
    lang93: "رسوم غرفة اللعبة",
    lang94: "انتصارات",
    lang95: "اللاعب",
    lang96: "ندى التسوية",
    lang97: "رسوم المباراة",
    lang98: "الرهان الأساسي",
    lang99: "/مباراة",
    lang100: "نتائجي",
    lang101: "اللاعبون",
    lang102: "السجلات",
  },
  teenPatti: {
    recordTitle: "السجلات",
    rankingTitle: "لوحة المتصدرين",
    confirm: "تأكيد",
    // 玩法设定页：配置与加入暂用 mock，接口接入后移除模拟提示。
    settingsTitle: "إعدادات اللعبة",
    maxBet: "الحد الأقصى لرهان الندى",
    maxPot: "الحد الأقصى لمجموع الرهانات",
    buyInDew: "الندى للدخول",
    mockJoinTip: "وضع تجريبي: تم اختيار ندى الأساس {ante}. الانضمام غير متاح بعد.",
    // 社团名称由 i18n-t 插槽提供，保持各语言的正确语序。
    clubPkRoom: "غرفة PK الخاصة بـ {club}",
    // 三张牌规则页文案：暂沿用此前的英文回退内容，待补充本语言翻译。
    title: "How to play",
    hands: "Hands",
    play: "Rules",
    order: "Hands ranked from highest to lowest",
    players: "Players: 2–5",
    mode: "Game mode:",
    intro: "Teen Patti is a strategy game in which players compare three-card hands. Read your hand and your opponents’ Dew wagers, then call, raise or compare hands to compete for the Dew in the pot. Suits do not determine hand strength.",
    flow: "Game flow",
    ante: "ندى الأساس",
    anteText: "At the start of each game, the fixed base Dew set by the host is automatically deducted from every player and added to the pot.",
    deal: "Dealing",
    dealText: "Each player receives 3 face-down cards. Only the player can view their own cards after choosing to look at them.",
    turn: "Turns",
    turnText: "Players act in order until only one player remains, the pot limit is reached or the round limit is reached.",
    actions: "Player actions",
    blind: "Blind",
    blindText: "Wager Dew without looking at your cards. Calls and raises cost 1× the current Dew wager.",
    seen: "Seen",
    seenText: "Continue playing after viewing your cards. Calls and raises cost twice the blind player’s Dew wager.",
    compare: "Compare hands",
    condition: "Availability",
    conditionText: "Players can request a comparison from the second round onwards.",
    cost: "Cost",
    costText: "Requesting a comparison costs twice the current single Dew wager.",
    compareResult: "Result",
    compareResultText: "The requester can privately compare with any active player. If both hands have exactly the same type and ranks, the requester loses. The losing player is eliminated from the game.",
    fold: "Fold",
    foldText: "Leave the current game. Dew already contributed to the pot is not refunded.",
    allIn: "All in",
    allInText: "If your balance cannot cover the minimum call, you can put your entire remaining balance into the pot. You cannot take any more actions that game, but your hand is kept until the final showdown.",
    settlement: "Settlement",
    end: "Round limit",
    endText: "Each game has a maximum number of rounds to keep play moving. Refer to the limit displayed in the room.",
    showdown: "Showdown",
    showdownText: "When the round limit is reached, or only two players remain and one requests a showdown, the system reveals the remaining hands for a final comparison.",
    reward: "Dew reward",
    rewardText: "The winner receives the entire pot after the platform’s fixed-percentage service fee or commission has been deducted.",
    hand1: "Three of a kind",
    desc1: "Three cards of the same rank, such as AAA or 222",
    hand2: "Straight flush",
    desc2: "Three consecutive cards of the same suit, such as 4–5–6 of spades",
    hand3: "Flush",
    desc3: "Three cards of the same suit that are not consecutive",
    hand4: "Straight",
    desc4: "Three consecutive cards of mixed suits, such as 5♥, 6♦, 7♠",
    hand5: "Pair",
    desc5: "Two cards of the same rank and a third card, such as 223",
    hand6: "High card",
    desc6: "A hand that does not form any of the combinations above",
    hand7: "235",
    desc7: "A mixed-suit 2, 3 and 5 beats three of a kind only when a three-of-a-kind hand is present at the table. Otherwise, 235 is treated as a high-card hand.",
    rankOrder: "Within a hand type, A is highest and 2 is lowest. AAA is the highest three of a kind; 222 is the lowest. For straights and straight flushes, A–K–Q is highest and 3–2–A is lowest.",
    sameHand: "For flushes and high-card hands, compare the highest card first, then the second and third cards if tied. Suits have no ranking.",
    samePair: "For pairs, compare the pair first, then the remaining card if tied.",
    lang1: "فتح غرفة",
    lang2: "انضمام سريع",
    lang3: "الدخول",
    lang4: "قيد الانتظار",
    lang5: "لا توجد غرف Teen Patti PK حاليًا",
    lang6: "وضع اللعب",
    lang7: "النادي الافتراضي",
    lang8: "كلاسيكي",
    lang9: "غير محدود",
    lang10: "السجل",
    lang11: "الترتيب",
    lang12: "ندى الدخول",
    lang13: "معلومات اللعب",
    lang16: "ادفع ندى الدخول للانضمام إلى Ludo PK",
    lang17: "عدد اللاعبين",
    lang18: "مكافآت الفوز",
    lang19: "السمعة",
    lang20: "أدواتي",
    lang21: "القطعة",
    lang22: "اللوحة",
    lang23: "اختر أداة القطعة التي تريد استخدامها في لعبة LUDO.",
    lang24:
      "اختر أداة اللوحة التي سيستخدمها ناديك في غرفة PK الخاصة بلعبة LUDO.",
    lang25: "شارة الوقت",
    lang26: "تم الاختيار",
    lang27: "افتراضي",
    lang28: "يرجى اختيار أداة",
    lang31: "استخدام",
    lang32: "اضغط لاختيار الأداة التي تريد استخدامها",
    lang33: "اضغط للاستخدام، ستستخدم لعبة LUDO التالية أداة اللوحة هذه",
    lang34: "اضغط للاستخدام، ستستخدم لعبة LUDO التالية أداة القطعة هذه",
    lang35: "قيد الاستخدام",
    lang36: "يرجى اختيار الأداة التي تريد استخدامها",
    lang37: "تم الاستخدام بنجاح، وسيصبح ساريًا في لعبة LUDO التالية",
    lang38: "يوم",
    lang39: "ساعة",
    lang40: "دقيقة",
    lang42: "لا توجد سجلات Teenpatti PK حاليًا",
    lang43: "تفاصيل اللعبة",
    lang45: "رسوم الغرفة",
    lang46: "الوقت",
    lang47: "الندى",
    lang49: "التاريخ",
    lang50: "الإجمالي",
    lang51: "صور اللاعبين",
    lang52: "الترتيب",
    lang53: "المركز 1",
    lang54: "المركز 2",
    lang55: "المركز 3",
    lang56: "المركز 4",
    lang57: "جارٍ التحميل...",
    lang58: "خدمة العملاء",
    lang59: "فوز",
    lang60: "خسارة",
    lang61: "تعادل",
    lang62: "شرح طريقة اللعب",
    lang63: "قواعد اللعبة",
    lang64: "عدد اللاعبين",
    lang66: "تحديد الفوز والخسارة",
    lang68: "سمعة النادي",
    lang69: "المشاركة في اللعبة",
    lang70: "الانضمام أثناء اللعب",
    lang72: "الإقلاع",
    lang73: "ثلاث ستات متتالية",
    lang74: "الحركة",
    lang75: "تكديس القطع",
    lang76: "أكل القطع",
    lang77: "المنطقة الآمنة",
    lang78: "2-4 لاعبين",
    lang79:
      "كلاسيكي: يجب أن تبدأ قطع اللاعب من نقطة البداية وتدور حول اللوحة دورة كاملة ثم تصل إلى النهاية. عندما تصل جميع القطع إلى النهاية تعتبر اللعبة مكتملة. كلما أنهيت اللعبة أسرع كان ترتيبك أعلى.",
    lang80:
      "وفقًا لوضع اللعب، يحصل اللاعب الذي ينهي اللعبة أولًا على ترتيب أعلى. على سبيل المثال، اللاعب الأول الذي ينهي اللعبة يكون صاحب المركز الأول في هذه الجولة، وهكذا.",
    lang81:
      "بعد انتهاء اللعبة، يمكنك الحصول على مكافآت الندى والسمعة حسب ترتيبك.",
    lang82:
      "إذا فزت باللعبة داخل غرفة النادي التي انضممت إليها، فستزداد سمعتك في ذلك النادي وفقًا لترتيبك في اللعبة.",
    lang83: "ادفع ندى الدخول الذي حدده مالك الغرفة للانضمام إلى اللعبة.",
    lang84:
      "في الألعاب التي بدأت بالفعل، يمكن للاعبين دفع ندى الدخول للانضمام إلى Ludo PK في منتصف اللعبة.",
    lang85:
      "يجب أن ترمي النرد وتحصل على الرقم ستة حتى تتمكن القطعة من الإقلاع من القاعدة إلى خانة البداية.",
    lang86:
      "إذا تم رمي الرقم ستة 3 مرات في نفس الدور، فسيتم تفعيل ثلاث ستات متتالية، وسيتجاوز اللاعب هذا الدور.",
    lang87:
      "يرمي اللاعب النرد للحصول على النقاط وتحريك القطعة إلى الأمام بعدد الخطوات المقابل.",
    lang88:
      "إذا توقفت قطع اللاعب نفسه في المكان نفسه فإنها تصبح تكديسًا. وعند أكلها تُعاد جميع القطع المكدسة إلى القاعدة.",
    lang89:
      "إذا توقفت القطعة بعد الحركة على خانة يوجد عليها قطعة لاعب آخر، فسيتم إعادة جميع قطع ذلك اللاعب إلى القاعدة، ويجب أن تقلع من جديد قبل أن تتمكن من الحركة.",
    lang90:
      "القطع التي تقف على نقطة البداية أو على الخانات ذات الدرع على اللوحة لا يمكن أكلها. ويمكن لقطع لاعبين مختلفين التوقف في هذه الخانات في الوقت نفسه.",
    lang91:
      "تُحصَّل في كل لعبة كمية ثابتة من الندى كرسوم للغرفة. ويتم تحديد مبلغ رسوم الغرفة وفقًا لكمية ندى الدخول، ولا يرتبط بعدد اللاعبين. وعند تسوية مكافآت الندى بعد انتهاء اللعبة، سيقوم النظام بخصم رسوم الغرفة تلقائيًا قبل صرف مكافآت الندى للفائز.",
    lang92: "الانضمام إلى اللعبة",
    lang93: "رسوم غرفة اللعبة",
    lang94: "انتصارات",
    lang95: "اللاعب",
    lang96: "ندى التسوية",
    lang97: "رسوم المباراة",
    lang98: "ندى الأساس",
  },
};
